import React, { useCallback, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../../../../../store/hooks'
import { selectAccountId } from '../../../../../../store/auth/authSlice'
import { usePollingEffect } from '../../../common/hooks/usePollingEffect'
import { useLazyListRoomEventsQuery } from '../../../../../../store/media/media'
import { selectFormEventPollingEnabled, setFormEventsForPolling } from '../../../../../../store/meetingSummary/forms'

export const FormEventPoller: React.FC = () => {
  const { roomId = '', sessionId = '' } = useParams()
  const accountId = useAppSelector(selectAccountId)

  usePollFormEvents(accountId, roomId, sessionId)

  return null
}

const usePollFormEvents = (accountId: string, roomId: string, sessionId: string) => {
  const dispatch = useAppDispatch()

  const [triggerGetRoomEvents] = useLazyListRoomEventsQuery()

  const formEventPollingEnabled = useAppSelector(selectFormEventPollingEnabled)

  const getFormEvents = useCallback(async () => {
    const { data: roomEvents } = await triggerGetRoomEvents({
      accountId,
      roomId,
      sessionId,
      pageRequest: { page: 0, size: 500 },
      types: ['aiFeatureExecutionFinished', 'userAllocationUpdated'],
    })
    if (!roomEvents?.data) {
      return
    }
    dispatch(setFormEventsForPolling(roomEvents.data))
  }, [triggerGetRoomEvents, accountId, roomId, sessionId, dispatch])

  const { start: startFormEventsPolling, stop: stopFormEventsPolling } = usePollingEffect(getFormEvents, [], {
    interval: 7000,
  })

  useEffect(() => {
    if (formEventPollingEnabled) {
      startFormEventsPolling()
    } else {
      stopFormEventsPolling()
    }
  }, [formEventPollingEnabled, startFormEventsPolling, stopFormEventsPolling])
}
